const saveToLocalStorage = ({ name, data }) => {
  let appData = JSON.parse(localStorage.getItem('photoReference'));
  if (appData) {
    appData[name] = data;
    localStorage.setItem('photoReference', JSON.stringify(appData));
  } else {
    appData = {
      [name]: data,
    };
    localStorage.setItem('photoReference', JSON.stringify(appData));
  }
};

export default saveToLocalStorage;
